var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinancialIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.947 17.917l-2.43-13.776a3.451 3.451 0 00-3.992-2.796L4.69 5.02a3.45 3.45 0 00-2.796 3.993l.179 1.012A3.451 3.451 0 000 13.185V26.83a3.45 3.45 0 003.447 3.447h20.681a3.45 3.45 0 003.447-3.447v-4.64l1.576-.279a3.425 3.425 0 002.225-1.417c.528-.754.73-1.669.57-2.576zm-2.111 1.497c-.24.343-.6.572-1.012.645l-1.25.22v-7.094a3.45 3.45 0 00-3.446-3.447H3.932l-.185-1.053c-.073-.412.02-.827.26-1.17.24-.343.599-.572 1.01-.645l20.834-3.673a1.57 1.57 0 011.815 1.27l2.43 13.777c.072.412-.02.828-.26 1.17zm-5.708 8.982H3.447A1.568 1.568 0 011.88 26.83v-6.681h23.815v6.681c0 .864-.703 1.567-1.567 1.567zM3.447 11.618h20.681c.864 0 1.567.703 1.567 1.567v.818H1.88v-.818c0-.864.703-1.567 1.567-1.567zm22.248 4.265v2.385H1.88v-2.385h23.815z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.047 24.621H4.782a.94.94 0 000 1.88h4.265a.94.94 0 000-1.88z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/financial-industry.e79f4f3d440bdf0b43c9602cdc9686c6.svg";
export { SvgFinancialIndustry as ReactComponent };